import * as types from "./ActionTypes";

export function addActiveApiCall(api) {
  return { type: types.ADD_ACTIVE_API_CALL, api };
}
